import styled from "styled-components";
import background_login from "../../assets/images/background-login-client.png";

export const Container = styled.div`
  height: 100vh;
  background-image: url(${background_login});
  background-size: cover;
`;

export const Header = styled.div`
  height: 265px;
`;

export const Content = styled.div`
  width: 420px;
  height: fit-content;
  padding: 40px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  z-index: 2;
  border-radius: 10px;
  margin-left: 11%;
  margin-top: 10px;
`;

export const Image = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  img {
    width: 221px;
    height: auto;
  }
`;

export const Form = styled.div`
  padding: 0px 0px;
`;

export const Title = styled.p`
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.title_login};
  margin-bottom: 0px;
`;

export const Text = styled.p`
  width: 95%;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.text_login};

  b {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    cursor: pointer;
  }
`;

export const InputAndLabel = styled.div`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
  }

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 0px;
    margin-top: 20px;
  }

  label {
    margin-top: 20px;
    margin-bottom: 2px;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.text_login};
  }

  #email {
    margin-top: 0px;
  }
`;

export const LabelPassword = styled.p`
  cursor: pointer;
`;

export const ContainerButton = styled.div`
  margin-top: 15%;
`;
